module.exports = {
	extends: [
		'/',
		'base',
		'master',
		'master'
	],

	config: {
		isCacheable: false
	}
};